export default __webpack_public_path__ + "static/media/Collab12.d8f21f78.png";